import { render, staticRenderFns } from "./ToolbarLibraryRevision.vue?vue&type=template&id=1471e352"
import script from "./ToolbarLibraryRevision.vue?vue&type=script&lang=js"
export * from "./ToolbarLibraryRevision.vue?vue&type=script&lang=js"
import style0 from "./ToolbarLibraryRevision.vue?vue&type=style&index=0&id=1471e352&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports